var _circle, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _g2, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectDocuments({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.5008,
    cy: 52.0887,
    r: 3.23714,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10168_14205)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.88672,
    y: 28.8398,
    width: 35.9029,
    height: 45.32,
    rx: 2.35429,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.1406,
    y: 36.7842,
    width: 12.8426,
    height: 1.78416,
    rx: 0.89208,
    fill: "#60A5FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1406,
    y: 63.4727,
    width: 20.2929,
    height: 1.78416,
    rx: 0.89208,
    fill: "#D1D5DB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1406,
    y: 47.415,
    width: 24.5857,
    height: 1.78416,
    rx: 0.89208,
    fill: "#D1D5DB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1406,
    y: 42.0635,
    width: 20.2929,
    height: 1.78416,
    rx: 0.89208,
    fill: "#D1D5DB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1406,
    y: 52.7686,
    width: 7.004,
    height: 1.78416,
    rx: 0.89208,
    fill: "#60A5FA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1406,
    y: 58.1211,
    width: 11.6773,
    height: 1.78416,
    rx: 0.89208,
    fill: "#60A5FA"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_10168_14205)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.623,
    y: 28.8398,
    width: 35.9029,
    height: 45.32,
    rx: 2.68471,
    fill: "white"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 64.8267,
    y: 38.3746,
    width: 27.7863,
    height: 5.06171,
    rx: 0.470857,
    fill: "white",
    stroke: "#D1D5DB",
    strokeWidth: 0.235429
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 64.8267,
    y: 49.5581,
    width: 27.7863,
    height: 5.06171,
    rx: 0.470857,
    fill: "white",
    stroke: "#D1D5DB",
    strokeWidth: 0.235429
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 64.8267,
    y: 60.7408,
    width: 27.7863,
    height: 5.06171,
    rx: 0.470857,
    fill: "white",
    stroke: "#D1D5DB",
    strokeWidth: 0.235429
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 64.709,
    y: 35.9033,
    width: 12.8433,
    height: 1.76571,
    rx: 0.882857,
    fill: "#60A5FA"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 64.709,
    y: 47.0859,
    width: 7.00544,
    height: 1.76571,
    rx: 0.882857,
    fill: "#60A5FA"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 64.709,
    y: 58.2686,
    width: 11.6757,
    height: 1.76571,
    rx: 0.882857,
    fill: "#60A5FA"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 42.9648,
    y: 44.1426,
    width: 16.48,
    height: 16.48,
    rx: 8.24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.0841 52.2928C47.0841 50.8283 47.8566 49.4764 49.1441 48.7361C50.4155 47.9958 51.9766 47.9958 53.2641 48.7361C54.5355 49.4764 55.3241 50.8283 55.3241 52.2928C55.3241 53.7734 54.5355 55.1253 53.2641 55.8656C51.9766 56.6059 50.4155 56.6059 49.1441 55.8656C47.8566 55.1253 47.0841 53.7734 47.0841 52.2928ZM51.6064 54.3689L53.4089 52.5664C53.5538 52.4216 53.5538 52.1802 53.4089 52.0192L51.6064 50.2328C51.4455 50.0719 51.2041 50.0719 51.0592 50.2328C50.8983 50.3777 50.8983 50.6191 51.0592 50.7639L52.2019 51.9066H49.2728C49.0475 51.9066 48.8866 52.0836 48.8866 52.2928C48.8866 52.5181 49.0475 52.6791 49.2728 52.6791L52.2019 52.6952L51.0592 53.8378C50.8983 53.9827 50.8983 54.2241 51.0592 54.3689C51.2041 54.5298 51.4455 54.5298 51.6064 54.3689Z",
    fill: "#60A5FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10168_14205",
    x: 2.35529,
    y: 26.4856,
    width: 42.9652,
    height: 52.3832,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.17714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.76571
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10168_14205"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10168_14205",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_10168_14205",
    x: 56.596,
    y: 26.1551,
    width: 43.9565,
    height: 53.3744,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.34236
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.01353
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10168_14205"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10168_14205",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectDocuments);
export default __webpack_public_path__ + "static/media/select-documents.9b6be62bdd2e05760d0ade12c2333ce0.svg";
export { ForwardRef as ReactComponent };